<template>

  <v-list dense nav>
    <template v-for="item in items">

      <template v-if="item.sub.length == 0">

        <v-list-item v-if="item.href && canShowMenuItem(item)" link :href="item.href" target="_blank" rel="noopener">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ $t(item.title) }} <v-icon x-small>mdi-open-in-new</v-icon></v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item  link :to="item.link" v-else-if="canShowMenuItem(item)">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </template>

      <template v-else>

        <v-list-group :prepend-icon="item.icon" no-action v-if="canShowMenuItem(item)">

          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="subItem in item.sub" :key="subItem.title" :to="subItem.link" link v-if="canShowMenuItem(subItem)">
            <v-list-item-content>
              <v-list-item-title>{{ $t(subItem.title) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

      </template>

    </template>
  </v-list>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {MARKETING_URL} from "@/utils/platforms";

export default {
  name: "MenuLeft",
  computed: {
    ...mapGetters({
      'getUser': 'user/getUser',
      'getPermissions': 'permissions/getPermissions'
    }),
  },
  async created() {

    let result_roles = await this.getListRole()
    let roles = result_roles.role.map((r) => ({ text: this.$t(r.name), value: r._id }));
    await this.setRoles(roles);


    if(!this.getUser.super_admin){

      const role = roles.find(r => r.value === this.getUser.role_id);
      await this.setRoleName(role.text);

      var permissions = await this.permissionList({id:this.getUser.role_id})

      for(let item of this.items){

        if(item.module != 'centers' && item.module != 'fields'){
          if(!permissions.includes(item.module) && this.$route.path.includes(item.link)){
            await this.logout()
          }

          if(item.sub.length > 0){
            for(let sub of item.sub){
              if(!permissions.includes(sub.module) && this.$route.path.includes(sub.link)){
                await this.logout()
              }
            }
          }
        }

        if(item.module === 'center-admin'){
          this.items.push(        {
            title: 'myCenter', icon: 'mdi-stadium-variant', link: '#', module: 'my_center',
            sub: [
              {title: 'fixed_bookings', icon: '', link: '/fixed-bookings/edit/'+this.getUser.center_id, module: 'my_center.fixed_bookings'},
              {title: 'closures', icon: '', link: '/closures/'+this.getUser.center_id, module: 'my_center.closures'},
              {title: 'settings', icon: '', link: '/centers/edit/'+this.getUser.center_id, module: 'my_center.settings'},
              {title: 'info', icon: '', link: '/centers/info/'+this.getUser.center_id, module: 'my_center.info'},
              {title: 'media', icon: '', link: '/centers/media/'+this.getUser.center_id, module: 'my_center.media'},
              {title: 'configurations', icon: '', link: '/centers/configurations/'+this.getUser.center_id, module: 'my_center.settings'},
              {title: 'users', icon: '', link: '/collaborators/', module: 'my_center.users'},
            ]
          },)
        }

        if(item.module === 'fields'){
          this.items.push({
            title: 'myFields', icon: 'mdi-soccer-field', link: `/fields`, module: 'my_fields', sub: []},
          )
        }

      }
    }

  },
  data () {
    return {
      items: [
        {title: 'dashboard', icon: 'mdi-view-dashboard', link: '/dashboard', module: 'dashboard', sub: []},
        {title: 'reportPromoSuperAdmin', icon: 'mdi-format-list-text', link: '/report-promo-superadmin', module: 'report-promosa', sub: []},
        {title: 'PromoSuperAdminGlobal', icon: 'mdi-sack-percent', link: '/promo-sa-global', module: 'promo-sa-global', sub: []},
        {title: 'sportsCenter', icon: 'mdi-stadium-variant', link: '/centers', module: 'centers', sub: []},
        {title: 'fields', icon: 'mdi-soccer-field', link: '/fields', module: 'fields', sub: []},
        {title: 'bookingsManagement', icon: 'mdi-calendar', link: '/bookings-management', module: 'bookings', sub: []},
        {title: 'bookingList', icon: 'mdi-format-list-bulleted', link: '/bookings', module: 'bookings', sub: []},
        {title: 'cancellations', icon: 'mdi-cash-refund', link: '/cancellations', module: 'cancellations', sub: []},
        {title: 'transactions', icon: 'mdi-piggy-bank', link: '/transactions', module: 'transactions', sub: []},
        {title: 'promo-codes', icon: 'mdi-barcode-scan', link: '/promo-codes', module: 'promo-codes', sub: []},
        {title: 'adminsCenter', icon: 'mdi-account-group', link: '/center-admin', module: 'center-admin', sub: []},
        {title: 'customers', icon: 'mdi-account-convert', link: '/customers', module: 'customers', sub: []},
        {title: 'pushNotifications', icon: 'mdi-bell-ring', link: '/push-notifications', module: 'push-notifications', superOnly: true, sub: []},
        // UCAMP-87 plan 9: rimando alla piattaforma marketing (stesse credenziali dei superadmin)
        {title: 'marketingPlatform', icon: 'mdi-bullhorn-outline', href: MARKETING_URL, module: 'marketing', superOnly: true, sub: []},
        {title: 'openMatches', icon: 'mdi-account-group-outline', link: '/matches/open', module: 'matches.open', superOnly: true, sub: []},
        {
          title: 'matchStats', icon: 'mdi-chart-bar', link: '#', module: 'match-stats', superOnly: true,
          sub: [
            {title: 'matchStatsMatches', icon: '', link: '/match-stats', module: 'match-stats.matches', superOnly: true},
            {title: 'matchStatsLeaderboard', icon: '', link: '/match-stats/leaderboard', module: 'match-stats.leaderboard', superOnly: true},
            {title: 'matchStatsUserOverride', icon: '', link: '/match-stats/user-override', module: 'match-stats.user-override', superOnly: true},
          ]
        },
        {title: 'reviews', icon: 'mdi-comment-text-multiple', link: '/reviews', module: 'reviews', sub: []},
        {title: 'blacklist', icon: 'mdi-ghost', link: '/blacklists', module: 'blacklist', sub: []},
        {title: 'analytics', icon: 'mdi-poll', link: '/analytics', module: 'analytics', sub: []},
        {title: 'Chatbot', icon: 'mdi-robot', link: '/chatbot', module: 'chatbot', sub: []},
        {
          title: 'cms', icon: 'mdi-file-document-edit-outline', link: '#', module: 'cms',
          sub: [
            {title: 'pages', icon: '', link: '/cms/pages', module: 'cms.pages'},
            // {title: 'email', icon: '', link: '/#', module: 'cms.email'},
          ]
        },
        {
          title: 'settings', icon: 'mdi-cog-outline', link: '#', module: 'settings',
          sub: [
            {title: 'sports', icon: '', link: '/settings/sports', module: 'settings.sports'},
            {title: 'sportsMaster', icon: '', link: '/settings/sports-config-master', module: 'settings.sports'},
            {title: 'cancellationReason', icon: '', link: '/settings/cancellation-reason', module: 'settings.cancellation-reason'},
            {title: 'features', icon: '', link: '/settings/features', module: 'settings.features'},
            {title: 'servicesCenter', icon: '', link: '/settings/services', module: 'settings.services'},
            {title: 'configurations', icon: '', link: '/settings/configurations', module: 'settings.configurations'},
            {title: 'superAdmin', icon: '', link: '/settings/super-admin', module: 'settings.super-admin'},
            {title: 'permissions', icon: '', link: '/settings/permissions', module: 'settings.permissions'},
          ]
        },
      ],
    }
  },
  methods:{
    ...mapMutations({
      'setRoles': 'permissions/setRoles',
      'setRoleName': 'user/setRoleName',
    }),
    ...mapActions({
      'permissionList': 'permissions/permissionList',
      'getListRole': 'permissions/getList',
      'logout': 'user/logout',
    }),
    canShowMenuItem(item){
      if(item.superOnly){
        return this.getUser.super_admin
      }
      return this.getUser.super_admin || this.getPermissions.includes(item.module)
    },
  }
}
</script>

<style scoped>

</style>
